<template>
    <div class="md-layout-item md-size-100">
        <modal v-if="showModal" @close="modalHide">
            <template slot="header">
                <h4 class="modal-title">{{ $t("add_hub") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="modalHide"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <md-card>
                    <md-card-header
                        class="md-card-header-icon md-card-header-blue"
                    >
                        <div class="card-icon">
                            <md-icon>router</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout-item md-size-100">
                            <form ref="form" id="hubForm">
                                <form-builder
                                    ref="formulario"
                                    @on-validated="onFormValidated"
                                    :value="item"
                                    :model="datosFormulario"
                                    :schema="formData"
                                >
                                </form-builder>
                            </form>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button class="md-danger md-simple" @click="modalHide">{{
                    $t("cancel")
                }}</md-button>
                <md-button @click="submit()" class="md-success"
                    >{{ $t("save") }}
                </md-button>
            </template>
        </modal>

        <modal v-if="showHistory" @close="showHistory = false">
            <template slot="header">
                <h4 class="modal-title">{{ $t("historial") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="showHistory = false"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <md-card>
                    <md-card-header
                        class="md-card-header-icon md-card-header-blue"
                    >
                        <div class="card-icon">
                            <md-icon>history</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout-item md-size-100">
                            <md-table
                                v-model="historyList"
                                md-card
                                md-fixed-header
                            >
                                <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                >
                                    <md-table-cell :md-label="$t('status')">
                                        <md-icon
                                            v-if="item.isOnline"
                                            class="text-success"
                                            >lens</md-icon
                                        >
                                        <md-icon v-else class="text-gray"
                                            >lens</md-icon
                                        >
                                    </md-table-cell>
                                    <md-table-cell
                                        :md-label="$t('fecha_registro')"
                                        class="text-left"
                                        >{{
                                            $moment(
                                                item.fechaRegistro.date
                                            ).format("Y-MM-DD HH:mm:ss")
                                        }}
                                    </md-table-cell>
                                    <md-table-cell :md-label="$t('hub_code')">
                                        {{ item.codigo }}
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button
                    class="md-danger md-simple"
                    @click="showHistory = false"
                    >{{ $t("cancel") }}</md-button
                >
            </template>
        </modal>

        <modal
            v-if="showMonth"
            modalSize="modal-container-xl"
            @close="showMonth = false"
        >
            <template slot="header">
                <h4 class="modal-title">{{ $t("historial") }}</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="showMonth = false"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>
            <template slot="body">
                <md-card>
                    <md-card-header
                        class="md-card-header-icon md-card-header-blue"
                    >
                        <div class="card-icon">
                            <md-icon>history</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content
                        style="max-height: 600px; overflow-y: scroll !important"
                    >
                        <div class="md-layout-item md-size-100">
                            <!-- Pinto una grafica por hub -->
                            <div id="synced-charts">
                                <apexchart
                                    v-for="item in hisotrialMes"
                                    :key="item.hub"
                                    type="line"
                                    height="160"
                                    :options="getOptions(item)"
                                    :series="item.series"
                                ></apexchart>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </template>

            <template slot="footer">
                <md-button
                    class="md-danger md-simple"
                    @click="showMonth = false"
                    >{{ $t("cancel") }}</md-button
                >
            </template>
        </modal>

        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                    <md-icon>router</md-icon>
                </div>
                <h4 class="title">{{ $t(tableTitle) }}</h4>
                <md-button
                    class="md-primary pull-right"
                    @click="verHistorialMes()"
                    >{{ $t("historial") }}
                </md-button>
            </md-card-header>
            <md-card-content>
                <md-table table-header-color="green">
                    <md-table-row>
                        <md-table-head>ID</md-table-head>
                        <md-table-head>{{ $t("status") }}</md-table-head>
                        <md-table-head>{{ $t("last_online") }}</md-table-head>
                        <md-table-head>{{ $t("code") }}</md-table-head>
                        <md-table-head>{{ $t("tag") }}</md-table-head>
                        <md-table-head></md-table-head>
                    </md-table-row>

                    <md-table-row
                        v-for="(data, i) in response.lista"
                        :key="i"
                        slot="md-table-row"
                    >
                        <md-table-cell>{{ data.id }}</md-table-cell>
                        <md-table-cell v-if="estado(data) == 0">
                            <md-icon class="text-gray">lens</md-icon>
                        </md-table-cell>
                        <md-table-cell v-else>
                            <md-icon class="text-success">lens</md-icon>
                        </md-table-cell>
                        <md-table-cell>{{ data.lastTimeOnline }}</md-table-cell>
                        <md-table-cell>{{ data.codigo }}</md-table-cell>
                        <md-table-cell>{{ data.etiqueta }}</md-table-cell>
                        <md-table-cell class="text-right">
                            <md-button
                                v-if="permissionsAdminCentro"
                                class="md-just-icon md-primary"
                                @click="openModal(i)"
                            >
                                <md-icon>edit</md-icon>
                                <md-tooltip md-direction="top"
                                    >{{ $t("edit") }}
                                </md-tooltip>
                            </md-button>

                            <md-button
                                class="md-just-icon md-warning"
                                @click="verHistorial(i)"
                            >
                                <md-icon>history</md-icon>
                                <md-tooltip md-direction="top"
                                    >{{ $t("historial") }}
                                </md-tooltip>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <md-card-actions>
                <div class="md-layout md-alignment-bottom-left">
                    <div class="md-layout-item">
                        <md-icon class="text-success">lens</md-icon>
                        {{ $t("online") }}
                        <span style="width: 20px; display: inline-block"></span>
                        <md-icon class="text-black">lens</md-icon>
                        {{ $t("disconnected") }}
                    </div>
                </div>
            </md-card-actions>
        </md-card>
    </div>
</template>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import Modal from "../Modal";
import formBuilder from "../../formBuilder";
import { EventBus } from '../../helpers/EventBus';

export default {
    name: "hubs_list",
    components: { Modal, formBuilder },
    mounted() {
        this.fetchData();
        EventBus.$on('cambio-centro', this.fetchData);
    },
    data() {
        return {
            permissionsAdminCentro: false,
            formValidated: null,
            body: {},
            id: null,
            item: null,
            itemList: [],
            formData: [],
            hisotrialMes: [],
            showModal: false,
            showMonth: false,
            showHistory: false,
            isLoading: false,
            response: {},
            datosFormulario: {},
            historyList: [],
            tableTitle: "hubs_management",
        };
    },
    created() {
        this.setPermissions();
    },
    methods: {
         setPermissions() {
            let user = JSON.parse(localStorage.getItem("instantcare_user"));
            if (user.roles.includes("ROLE_CENTRO")) {
                this.permissionsAppQR = false;
                this.permissionsAdminCentro = true;
                this.permissionsAdminCadena = false;
            }
            if (user.roles.includes("ROLE_ENFERMERA")) {
                this.permissionsAppQR = true;
                this.permissionsAdminCentro = false;
                this.permissionsAdminCadena = false;
            }
        },
        estado: function (data) {
            if (data.encendido) {
                return 1;
            } else {
                return 0;
            }
        },
        destroy() {
            this.formValidated = null;
            this.body = {};
            this.id = null;
            this.item = null;
            this.itemList = [];
            this.historyList = [];
            this.formData = [];
            this.response = {};
            this.datosFormulario = {};
        },
        onFormValidated(model) {
            this.datosFormulario = { ...this.datosFormulario, ...model };
        },
        submit() {
            this.$refs["formulario"].validate().then((res) => {
                if (res) {
                    this.edit(this.datosFormulario);
                    this.modalHide();
                }
            });
        },
        edit(data) {
            let self = this;
            fetch(`${BACKEND_API}/api/hubs/edit/` + data.id, {
                method: "POST",
                headers: authHeader(),
                body: JSON.stringify(data),
            })
                .then(handleResponse)
                .then((response) => {
                    self.$notify({
                        message: self.$root.$t("hub_updated_successfully"),
                        icon: "add_alert",
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: "success",
                    });
                    this.fetchData();
                });
        },
        formConfig() {
            let self = this;
            fetch(`${BACKEND_API}/api/hubs/prepare`, {
                method: "GET",
                headers: authHeader(),
            })
                .then((response) => response.json())
                .then(function (data) {
                    self.formData = data[1];
                });
        },
        verHistorial(id) {
            this.historyList = [];
            let self = this;
            fetch(`${BACKEND_API}/api/hubs/history/${this.itemList[id].id}`, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    self.historyList = response;
                    self.showHistory = true;
                });
        },
        getOptions(hubInfo) {
            let chartOptions = {
                title: {
                    text: hubInfo.hub,
                },
                tooltip: {
                    enabled: true,
                },
                grid: {
                    show: false,
                },
                chart: {
                    id: hubInfo.hub,
                    group: "hubs",
                    type: "line",
                    height: "100px",
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    curve: "stepline",
                },
                colors: ["#008FFB"],
                xaxis: {
                    type: "datetime",
                    min: hubInfo.min,
                    max: hubInfo.max,
                    tooltip: {
                        enabled: true,
                    },
                    labels: {
                        datetimeFormatter: {
                            year: "yyyy",
                            month: "MMM 'yy",
                            day: "dd MMM",
                            hour: "HH:mm",
                        },
                    },
                },
                yaxis: {
                    labels: {
                        minWidth: 40,
                        show: false,
                    },
                },
            };
            return chartOptions;
        },
        verHistorialMes() {
            this.hisotrialMes = [];
            let self = this;

            let url = `${BACKEND_API}/api/hubs/month-history`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = url + `?idCentro=${currentCentro.id}`;
            }
            fetch(url, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    self.hisotrialMes = response;
                    self.showMonth = true;
                });
        },
        openModal(id) {
            this.id = id;
            this.item = this.itemList[id];
            this.datosFormulario = { ...{}, ...this.item };
            this.formConfig();
            this.showModal = true;
        },
        modalHide() {
            this.showModal = false;
        },
        deleteItem(id) {
            this.$swal({
                title: this.$root.$t("are_you_sure"),
                text: this.$root.$t("you_cannot_revert_the_operation"),
                type: "warning",
                showCancelButton: true,
                closeOnClickOutside: false,
                confirmButtonText: this.$root.$t("yes"),
                cancelButtonText: this.$root.$t("no"),
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-danger",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                let self = this;
                if (result.value) {
                    fetch(`${BACKEND_API}/api/hubs/baja/` + id, {
                        method: "GET",
                        headers: authHeader(),
                    })
                        .then(handleResponse)
                        .then((response) => {
                            self.$notify({
                                message: self.$root.$t(
                                    "hub_deleted_successfully"
                                ),
                                icon: "add_alert",
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });
                            this.fetchData();
                        });
                }
            });
        },
        fetchData() {
            let self = this;

            let url = `${BACKEND_API}/api/hubs/list`;
            let currentCentro = JSON.parse(sessionStorage.getItem("idCentro"));
            if (currentCentro) {
                url = `${BACKEND_API}/api/hubs/list?idCentro=${currentCentro.id}`;
            }
            fetch(url, {
                method: "GET",
                headers: authHeader(),
            })
                .then(handleResponse)
                .then((response) => {
                    self.response = response;
                    this.itemList = response.lista;
                    self.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
}

.md-table-row .md-table-cell:last-child {
    text-align: right;
}

.md-table-cell-container .md-button:not(:first-child) {
    margin-left: 3px;
    margin-right: 3px;
}

.md-table-cell-container .md-button:not(:last-child) {
    margin-left: 3px;
    margin-right: 3px;
}
</style>
